'use client'
import { Button, ButtonProps } from '@/components/ui/button'
import { MainRoutes } from '@/utils/routes'
import { signIn } from 'next-auth/react'
import { usePathname } from 'next/navigation'
import * as React from 'react'
import { usePostHog } from 'posthog-js/react'
import {
  ANALYTICS_APPLE_PROVIDER,
  APPLE_PROVIDER,
} from '@/modules/auth/constants'
import { AppleLogo } from '@/components/logos/apple'
import { cn } from '@/lib/css-utils'

export function SignInAppleButton(
  props?: ButtonProps,
): React.JSX.Element | null {
  const pathname = usePathname()
  const [isLoading, setIsLoading] = React.useState(false)
  const posthog = usePostHog()
  const onContinueWithApple = async () => {
    setIsLoading(true)
    if (pathname === MainRoutes.SignUp) {
      posthog.capture('clicked_signup', {
        screen_name: 'signup_landing',
        product_area: 'registration',
        module_name: 'main',
        signin_type: ANALYTICS_APPLE_PROVIDER,
      })
    } else if (pathname === MainRoutes.Login) {
      posthog.capture('clicked_signin', {
        screen_name: 'signin_landing',
        product_area: 'registration',
        module_name: 'main',
        signin_type: ANALYTICS_APPLE_PROVIDER,
      })
    }

    await signIn(APPLE_PROVIDER, {
      redirectTo: MainRoutes.Onboarding,
      redirect: true,
    })
  }
  return null

  return (
    <Button
      {...props}
      variant="outline"
      size="lg"
      className={cn('w-full flex gap-2 text-copy-primary', props?.className)}
      onClick={onContinueWithApple}
      isLoading={isLoading}
    >
      <AppleLogo className="w-5 h-auto" />

      <span>Continue with Apple</span>
    </Button>
  )
}
